if (!customElements.get("custom-product-as-variant")) {
    class CustomProductAsVariant extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.onVariantClick.bind(this));
  }

  onVariantClick(event) {
    event.preventDefault();

    // -------------------------
    // ACTIVE STATE — always update immediately for visual feedback
    // -------------------------
    const container = this.closest(".variant-container") || this.parentElement;
    if (container) {
      container.querySelectorAll(".thumbnail-swatch")
        .forEach(el => {
          el.classList.remove("active");
          el.classList.remove("is-selected");
        });
    }
    this.classList.add("active");
    this.classList.add("is-selected");

    // =========================
    // CHECK: Are we inside a product card? (Collection page, drawer, etc.)
    // =========================
    const productCard = this.closest(".product-card") || this.closest("product-card");

    if (productCard) {
      // =========================
      // PRODUCT CARD CONTEXT (Collection, Similar Products Drawer, etc.)
      // Fetch full product card HTML to update gallery, price, title, etc.
      // =========================
      
      // -------------------------
      // 1. UPDATE IMAGE INSTANTLY FOR FEEDBACK
      // -------------------------
      const img = productCard.querySelector(".product-card__image");
      const newImageSrc = this.dataset.image;

      if (img && newImageSrc) {
        img.src = newImageSrc;
        img.removeAttribute("srcset");
      }

      // -------------------------
      // 2. FETCH FULL CARD FOR SEAMLESS SWAP
      // -------------------------
      productCard.classList.add("is-loading");
      productCard.style.pointerEvents = 'none';

      const sectionUrl = this.dataset.variantUrl + (this.dataset.variantUrl.includes('?') ? '&' : '?') + 'section_id=api-product-card';

      fetch(sectionUrl)
        .then(res => res.text())
        .then(htmlText => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlText, "text/html");
          const newCard = doc.querySelector("product-card");

          if (!newCard) {
            throw new Error("Failed to parse new product card.");
          }

          // Swap function
          const swapCard = () => {
            productCard.replaceWith(newCard);
          };

          // Preload primary image to prevent blank flash
          const newPrimaryImg = newCard.querySelector('.product-card__image--primary') || newCard.querySelector('img');
          
          if (newPrimaryImg && (newPrimaryImg.src || newPrimaryImg.srcset || newPrimaryImg.dataset.src)) {
            const tempImg = new Image();
            tempImg.onload = swapCard;
            tempImg.onerror = swapCard;
            
            if (newPrimaryImg.srcset) {
               tempImg.srcset = newPrimaryImg.srcset;
               if (newPrimaryImg.sizes) tempImg.sizes = newPrimaryImg.sizes;
            } else {
               tempImg.src = newPrimaryImg.src || newPrimaryImg.currentSrc || newPrimaryImg.dataset.src;
            }
          } else {
            swapCard();
          }
        })
        .catch(err => {
          console.error("Product as Variant: card update error", err);
          productCard.classList.remove("is-loading");
          productCard.style.pointerEvents = '';
        });

      return; // Don't proceed to PDP fetch
    }

    // =========================
    // PRODUCT PAGE (PDP) — full page content swap via fetch
    // =========================
    const isProductPage = document.querySelector("safe-sticky.product-info");

    if (isProductPage) {
      fetch(this.dataset.variantUrl)
        .then(res => res.text())
        .then(htmlText => {
          const html = new DOMParser().parseFromString(htmlText, "text/html");

          const main = document.querySelector("#main");
          const newMain = html.querySelector("#main");

          if (main && newMain) {
            main.innerHTML = newMain.innerHTML;
          }

          // ✅ IMPORTANT: update URL
          window.history.pushState({}, "", this.dataset.variantUrl);
        });

      return;
    }
  }
}

customElements.define("custom-product-as-variant", CustomProductAsVariant);
}